import { Music } from "lucide-react";

const HymnsTileDesign = {
  id: "hymns",
  icon: Music,
  label: "Hymns",
  background: "#5F7D4D",
  color: "#ffffff",
};

export default HymnsTileDesign;
